module.exports = __webpack_public_path__ + "img/p4_4.08753600.png";